import { DEAL_SPLIT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import ObjectDefinitionRecord from '../ObjectDefinitionRecord';
import { DEAL_SPLIT_FILTER_GATE } from '../../permissions/gates';
const DealSplit = ObjectDefinitionRecord({
  enableAsAssociatedType: true,
  hasAccess: (isUngated, hasScope) => isUngated(DEAL_SPLIT_FILTER_GATE) && hasScope('deal-splits-access'),
  objectTypeId: DEAL_SPLIT_TYPE_ID,
  referenceObjectType: 'DEAL_SPLIT_PROPERTIES'
});
export default DealSplit;